import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import companyService from "../../services/companyService";
import AccountGuardModal from "./AccountGuardModal";

const AccountGuard = (props) => {

	let [ showGuard, setShowGuard ] = useState(false);
	
	const navigate = useNavigate();
	
	const handleGuardClose = () => {
		setShowGuard(false);
		navigate("/");
	};
	
	useEffect(() => {
		const company = companyService.selectedCompany;
		
		if (props.requiredService.toLowerCase() === "all") {
			setShowGuard(true);
		}
		
		if (company.id === 108) return;
		
		if (props.requiredService.toLowerCase() === "kynd" && !company.kynd_org_id) {
			setShowGuard(true);
		}
		else if (props.requiredService.toLowerCase() === "usecure" && !company.usecure_id) {
			setShowGuard(true);
		}
		else if (props.requiredService.toLowerCase() === "breachaware" && !company.breachaware_id) {
			setShowGuard(true);
		}
	}, [props.requiredService]);
	
	return (
		<React.Fragment>
			<AccountGuardModal
				open={showGuard}
				onClose={handleGuardClose}
			/>
		</React.Fragment>
	);

}

export default AccountGuard;